@if (isSplit && fares?.length) {
  <mat-accordion>
    <mat-expansion-panel class="split">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span i18n="@@splitTicketSplitTicketDetails">Split Ticket Details</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (fare of fares; track fare) {
        <div>
          <span class="split-fare-title">
            {{ fare.quantity }} x {{ fare.name }}:
            {{ fare.price ? (fare.price | currency: fare.currency) : 'See Outbound' }}
          </span>
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
}
